// src/components.js
// User
import AjouterUser from "./views/Settings/User/AjouterUser";
import ListUser from "./views/Settings/User/ListUser";

// Category
import AjouterCategory from "./views/Settings/Category/AjouterCategory";
import ListCategories from "./views/Settings/Category/ListCategories";

// Product
import AjouterProduct from "./views/Settings/Product/AjouterProduct";
import ListProducts from "./views/Settings/Product/ListProducts";

// Client
import AjouterClient from "./views/Settings/Client/AjouterClient";
import ListClients from "./views/Settings/Client/ListClients";

// Supplier
import AjouterSupplier from "./views/Settings/Supplier/AjouterSupplier";
import ListSuppliers from "./views/Settings/Supplier/ListSuppliers";

// Driver
import AjouterDriver from "./views/Settings/Drivers/AjouterDriver";
import ListDrivers from "./views/Settings/Drivers/ListDrivers";

// Car
import AjouterCar from "./views/Settings/Cars/AjouterCar";
import ListCars from "./views/Settings/Cars/ListCars";

// Brand
import AjouterBrand from "./views/Settings/Brands/AjouterBrand";
import ListBrands from "./views/Settings/Brands/ListBrands";

// Not Found
import NotFound from "./views/NotFound";

// Purchase Invoice
import ListPurchaseInvoice from "./views/Settings/Invoice/FactureList";
import AddPurchaseInvoice from "./views/Settings/Invoice/AddFacture";

// Sale Invoice List and Detail
import ListSaleInvoice from "./views/Settings/SaleInvoice/ListSaleInvoice";
import SaleInvoiceDetails from "./views/Settings/SaleInvoice/DetailFacture";

// NEW SEPARATED SALE INVOICE COMPONENTS
import AddDeliveryNote from "./views/Settings/SaleInvoice/AddSaleInvoice/DeliveryNote/AddDeliveryNote";
import UpdateDeliveryNote from "./views/Settings/SaleInvoice/AddSaleInvoice/DeliveryNote/UpdateDeliveryNote";
import AddSalesInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/SaleInvoice/AddSalesInvoice";
import UpdateSaleInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/SaleInvoice/UpdateSalesInvoice";
import AddShippingNoteInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/ShippingNote/AddShippingNoteInvoice";
import UpdateShippingNoteInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/ShippingNote/UpdateShippingNoteInvoice";

// Refund Invoice
import ListRefundInvoice from "./views/Settings/SaleInvoiceRefund/ListRefundInvoice";
import AddRefundInvoice from "./views/Settings/SaleInvoiceRefund/AddRefundInvoice";

// Payment Components
import AjouterPayment from "./views/Settings/Payments/AjouterPayment";
import ListPayments from "./views/Settings/Payments/ListPayments";

// Company Settings
import CompanySettings from "./views/CompanySettings";
import HeroBannerList from "./views/Settings/HeroBanner/ListHeroBanner";
import AjouterHeroBanner from "./views/Settings/HeroBanner/AjouterHeroBanner";
import DetailContact from "./views/Settings/Contact/DetailContact";
import ListContact from "./views/Settings/Contact/ListContact";
import ListOrders from "./views/Settings/Order/ListOrders";
import OrderDetails from "./views/Settings/Order/OrderDetails";

const Components = {
  // Existing
  ListUser,
  AjouterUser,
  NotFound,
  ListCategories,
  AjouterCategory,
  ListProducts,
  AjouterProduct,
  ListClients,
  AjouterClient,
  ListSuppliers,
  AjouterSupplier,
  AjouterBrand,
  ListBrands,
  AjouterHeroBanner,
  HeroBannerList,
  // Driver components
  AjouterDriver,
  ListDrivers,

  // Car components
  AjouterCar,
  ListCars,

  // Purchase Invoice components
  ListPurchaseInvoice,
  AddPurchaseInvoice,

  // Sale Invoice components
  ListSaleInvoice,
  SaleInvoiceDetails,

  // NEW SEPARATED SALE INVOICE COMPONENTS
  AddDeliveryNote,
  UpdateDeliveryNote,
  AddSalesInvoice,
  UpdateSaleInvoice,
  AddShippingNoteInvoice,
  UpdateShippingNoteInvoice,

  // Refund Invoice components
  ListRefundInvoice,
  AddRefundInvoice,

  // Payment components
  AjouterPayment,
  ListPayments,

  // Other
  CompanySettings,
  DetailContact,
  ListContact,
  OrderDetails,
  ListOrders,
};

export default Components;
